import React from 'react';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CustomMuiDropdown from '../../../../../../../../components/CustomMuiDropdown/CustomMuiDropdown';
import SearchStudent from '../SearchStudent/SearchStudent';

import s from './SearchDropdown.module.css';

function ResponseInput({ handleResponseSearch, searchResponseTerm }) {
  return (
    <div>
      <TextField
        fullWidth
        size="small"
        placeholder="Search Responses"
        onChange={(e) => handleResponseSearch(e.target.value)}
        value={searchResponseTerm}
        classes={{
          root: s.inputContainer,
        }}
        InputProps={{
          classes: {
            root: s.inputRoot,
            input: s.input,
          },
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {searchResponseTerm !== "" ? (
                <IconButton
                  className={s.clearIcon}
                  onClick={() => handleResponseSearch("")}
                  aria-label="clear"
                >
                  <ClearIcon />
                </IconButton>
              ) : (
                <IconButton className={s.searchIcon} aria-label="search">
                  <SearchIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}

function SearchDropdown({
  searchData,
  onStudentSelected,
  searchType,
  handleDropdown,
  handleResponseSearch,
  searchResponseTerm,
}) {
  const items = [
    {
      label: "Response",
      value: "response",
    },
    {
      label: "Student",
      value: "student",
    },
  ];
  return (
    <div className={s.dropdownContainer}>
      <CustomMuiDropdown
        onClickItem={handleDropdown}
        selectedValue={searchType.value}
        className={s.searchDropdownButton}
        optionsClassName={s.searchDropdownOptions}
        labelClassName={s.searchDropdownLabel}
        items={items}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      />
      {searchType.value === "response" && (
        <ResponseInput
          handleResponseSearch={handleResponseSearch}
          searchResponseTerm={searchResponseTerm}
        />
      )}
      {searchType.value === "student" && (
        <SearchStudent
          students={searchData}
          onStudentSelected={onStudentSelected}
        />
      )}
    </div>
  );
}

export default SearchDropdown;
